export const DEFAULT_CHAT_BUBBLE_COLOR = '#8145A8'

export const normalizeChatBubbleColor = (color?: string | null) => {
  const normalizedColor = color?.trim()
  if (!normalizedColor) return null

  // 旧版桌面弹窗把“默认色”错误保存成紫色；这里按默认设置处理，恢复角色主题色。
  if (
    normalizedColor.toLowerCase() === DEFAULT_CHAT_BUBBLE_COLOR.toLowerCase()
  ) {
    return null
  }

  return normalizedColor
}
